// extracted by mini-css-extract-plugin
module.exports = {"StatisticsHexagons":"styles_StatisticsHexagons____AcA","height":"styles_height__NIxmy"};